import { createContext } from 'react';

export type ResolvedLabel = {
  label: string;
  canonical: string;
  alias?: string;
  hasAlias: boolean;
};

export interface ReferenceAliasContextValue {
  displayMode: 'reference' | 'alias';
  resolve: (reference: string) => ResolvedLabel;
  aliasFor: (reference: string) => string | undefined;
  refresh: () => void;
}

const defaultResolve = (reference: string): ResolvedLabel => ({
  label: reference,
  canonical: reference,
  alias: undefined,
  hasAlias: false,
});

export const ReferenceAliasContext = createContext<ReferenceAliasContextValue>({
  displayMode: 'reference',
  resolve: defaultResolve,
  aliasFor: () => undefined,
  refresh: () => {},
});
